import type { RootState } from '../../configureStore';

const selectAnalyticsState = (state: RootState) => state.analytics;

export const selectAnalyticsOverview = (state: RootState) => selectAnalyticsState(state).overview;
export const selectAnalyticsRooms = (state: RootState) => selectAnalyticsState(state).rooms;
export const selectAnalyticsOverviewUnit = (state: RootState) =>
  selectAnalyticsState(state).overviewUnit;
export const selectAnalyticsRoomsUnit = (state: RootState) => selectAnalyticsState(state).roomsUnit;
export const selectAnalyticsOverviewLoading = (state: RootState) =>
  selectAnalyticsState(state).overviewLoading;
export const selectAnalyticsRoomsLoading = (state: RootState) =>
  selectAnalyticsState(state).roomsLoading;
export const selectAnalyticsOverviewError = (state: RootState) =>
  selectAnalyticsState(state).overviewError;
export const selectAnalyticsRoomsError = (state: RootState) =>
  selectAnalyticsState(state).roomsError;
